<template>
  <div>
    <div v-show="readonly" class="text-truncate">
      <span>{{ vorgDepFullName }}</span>
    </div>
    <div v-show="!readonly">
      <dep-cascader
        v-if="isWuCustomer"
        ref="dep"
        :lastValue.sync="vdepCode"
        :valueString.sync="vdisplayDepCode"
        :pathLabels.sync="vorgDepFullName"
        :size="size"
        :disabled="disabled"
        :placeholder="placeholder"
      />
      <cost-sector-select
        v-if="!isWuCustomer"
        ref="costSector"
        v-model="vdepCode"
        :custCode="custCode"
        :size="size"
        :disabled="disabled"
        :placeholder="placeholder"
        @change="costSectorChange"
      >
        <template #empty>
          <p class="el-select-dropdown__empty">
            {{ $l('tips_customer_no_costSector') || '客户未配置费用部门！' }}
          </p>
        </template>
      </cost-sector-select>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { request } from '@/api/service'
export default {
  props: {
    depCode: { type: String, default: '' },
    displayDepCode: { type: String, default: '' },
    orgDepFullName: { type: String, default: '' },
    custCode: { type: String, default: '' },
    placeholder: { type: String, default: 'Please select' },
    size: String,
    disabled: { type: Boolean, default: false },
    autoSelect: { type: Boolean, default: false },
    userCode: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      userInfo: {},
      wuCustomerInfo: {},
      depOptions: [],
    }
  },
  computed: {
    ...mapState('admin/user', { loginUser: 'info' }),
    vdepCode: {
      get() {
        return this.depCode
      },
      set(value) {
        this.$emit('update:depCode', value)
      },
    },
    vdisplayDepCode: {
      get() {
        return this.displayDepCode
      },
      set(value) {
        this.$emit('update:displayDepCode', value)
      },
    },
    vorgDepFullName: {
      get() {
        return this.orgDepFullName
      },
      set(value) {
        this.$emit('update:orgDepFullName', value)
      },
    },
    isWuCustomer() {
      if (!this.custCode) return true
      return this.custCode === this.wuCustomerInfo?.custCode
    },
    depOptionsMap() {
      return this.optionsToMap(this.depOptions)
    },
  },
  watch: {
    async userCode() {
      await this.getUser()
    },
  },
  async mounted() {
    await Promise.all([this.getUser(), this.getWuCustomer()])

    if (!this.autoSelect) return

    if (this.isWuCustomer) {
      this.depOptions = await this.$refs.dep.getOptions()
      const { depCode } = this.userInfo

      setTimeout(() => {
        if (!this.vdepCode) {
          this.vdepCode = depCode
          this.vdisplayDepCode = this.depOptionsMap[depCode]?.valuePath
          this.vorgDepFullName = this.userInfo.orgDepFullName
        }
      }, 0)
    } else {
      const costSectorOptions = await this.$refs.costSector.getOptions()
      this.vdepCode = (costSectorOptions?.length || 0) > 1 ? undefined : costSectorOptions[0]?.option?.depCode
      this.vdisplayDepCode = (costSectorOptions?.length || 0) > 1 ? undefined : costSectorOptions[0]?.option?.displayDepCode
      this.vorgDepFullName = (costSectorOptions?.length || 0) > 1 ? undefined : costSectorOptions[0]?.option?.orgDepFullName
    }
  },
  methods: {
    async getUser() {
      const res = await this.$api
        .sysUserDetailApi({
          userCode: !this.userCode ? this.loginUser.userCode : this.userCode,
        })
        .catch(() => null)

      this.userInfo = res?.body || {}
    },
    async getWuCustomer() {
      const res = await request({
        url: '/digitalCenter/masterCustomer/selectByNameWu',
        method: 'POST',
      }).catch(() => null)
      this.wuCustomerInfo = res?.body
    },
    costSectorChange(val, item, options) {
      const { displayDepCode, orgDepFullName } = options
      this.vdisplayDepCode = displayDepCode || ''
      this.vorgDepFullName = orgDepFullName || ''
    },
    optionsToMap(items) {
      const toList = (list, values = [], labels = []) => {
        return list.reduce((r, n) => {
          const { children, ...item } = n
          const t = {
            ...item,
            values: values.concat(item.value),
            labels: labels.concat(item.label),
          }

          r.push(t)
          if (children?.length) {
            r.push(...toList(children, t.values, t.labels))
          }

          return r
        }, [])
      }

      return Object.fromEntries(toList(items).map((o) => [o.value, o]))
    },
    clear() {
      setTimeout(async () => {
        if (this.isWuCustomer) {
          this.depOptions = await this.$refs.dep.getOptions()
          setTimeout(() => {
            if (!this.vdepCode) {
              const { depCode } = this.userInfo
              this.vdepCode = depCode
              this.vdisplayDepCode = this.depOptionsMap[depCode]?.valuePath
              this.vorgDepFullName = this.userInfo.orgDepFullName
            }
          }, 0)
        } else {
          const costSectorOptions = await this.$refs.costSector.getOptions()
          this.vdepCode = (costSectorOptions?.length || 0) > 1 ? undefined : costSectorOptions[0]?.option?.depCode
          this.vdisplayDepCode = (costSectorOptions?.length || 0) > 1 ? undefined : costSectorOptions[0]?.option?.displayDepCode
          this.vorgDepFullName = (costSectorOptions?.length || 0) > 1 ? undefined : costSectorOptions[0]?.option?.orgDepFullName
        }
      }, 500)
    },
  },
}
</script>
